
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as bets6bIjtVoox_45KJRtOlNLUlZ5u19hUMrMUlbQbKo0wFiG8Meta } from "/opt/buzztimeprobook/frontend/pages/bets.vue?macro=true";
import { default as indexpF_cTGbh8zwozdSoS1kL694b4F3VjlWX_vOy3eEK4_cMeta } from "/opt/buzztimeprobook/frontend/pages/index.vue?macro=true";
import { default as loginHSRodijiC_45PVjFMgm6cHRmm7UobpFdxLjDjtinNlLQ4Meta } from "/opt/buzztimeprobook/frontend/pages/login.vue?macro=true";
import { default as _91id_93as3Wn2x7zCz8eJIIA2023rdL0_4502T08GGSNCh2nVcKQMeta } from "/opt/buzztimeprobook/frontend/pages/dfs/[id].vue?macro=true";
import { default as registeriqUBHgiPwVja8VX5DWf5K17bYbNzx8CpTvsZQGOStE0Meta } from "/opt/buzztimeprobook/frontend/pages/register.vue?macro=true";
import { default as indexZa7Ti2iLnMPEzpG4E4K5zXVgx3CGg8yWNvX01v_q3AIMeta } from "/opt/buzztimeprobook/frontend/pages/dfs/index.vue?macro=true";
import { default as rakevHdQy4OSORrJ_45SNgd2CI8ppj_45N8dz4dWKiDtLDnaZj0Meta } from "/opt/buzztimeprobook/frontend/pages/admin/rake.vue?macro=true";
import { default as indexRyUaxaoLNpIZH_zMWEVn_451rpYI_45Hb7thMdpwg9vXJuMMeta } from "/opt/buzztimeprobook/frontend/pages/cash/index.vue?macro=true";
import { default as indexfxjTYgG5ZQK_45TxzP_456oQNhQsoJiQrpe1EaaNq82M7ykMeta } from "/opt/buzztimeprobook/frontend/pages/admin/index.vue?macro=true";
import { default as ticketsSAzusrugNV1wtrEdMNNg_456y7fXrHfp8ijFXCNAo4oFoMeta } from "/opt/buzztimeprobook/frontend/pages/dfs/tickets.vue?macro=true";
import { default as _91doc_93AvZeMMl3jaaA_j2KUTjZVfDhMsL9FzTe6YHnyiOf9DAMeta } from "/opt/buzztimeprobook/frontend/pages/legal/[doc].vue?macro=true";
import { default as leaderboardsBrfxpNmXfjjwXjsOgL4RSMX15gT287Ep5F887fpHuXwMeta } from "/opt/buzztimeprobook/frontend/pages/leaderboards.vue?macro=true";
import { default as indexWGym55gZiYD2N9yvBKTijkhpPxEHYoQohN4z2xaY9PoMeta } from "/opt/buzztimeprobook/frontend/pages/wallet/index.vue?macro=true";
import { default as verify2z5f3fr8qO6Znvi5R2IyRA5H9lLn1i9Z5DZNw9WVSpgMeta } from "/opt/buzztimeprobook/frontend/pages/account/verify.vue?macro=true";
import { default as _91id_9329av24Bv5Zhx_w0yRvy2_0yr_x6nfowZWqLtylghKOgMeta } from "/opt/buzztimeprobook/frontend/pages/dfs-event/[id].vue?macro=true";
import { default as index640iVlzVwJKMJuI6kklWe8nGt74g8IaIc2yUYpzZAmoMeta } from "/opt/buzztimeprobook/frontend/pages/scoreboard/index.vue?macro=true";
import { default as _91id_93vZDhGmkUb_HCDmiVzguFYR4Da5LmapJuNBY0hjfyBz0Meta } from "/opt/buzztimeprobook/frontend/pages/event/[sport]/[id].vue?macro=true";
import { default as transactionsa6NjkilvpC8ggKLdv_45irJTSINpaGWiHR97KmTgOTSlYMeta } from "/opt/buzztimeprobook/frontend/pages/wallet/transactions.vue?macro=true";
import { default as _91id_93u4imroyXgX_lwB3V6bTF_l3iThszGuK7ECDySUwjx5kMeta } from "/opt/buzztimeprobook/frontend/pages/scoreboard/game/[id].vue?macro=true";
import { default as _91id_93HR_45QNslUqGM5Nzm9L9kjuAHIimFqjLErp_45IyJSWAy7kMeta } from "/opt/buzztimeprobook/frontend/pages/scoreboard/team/[id].vue?macro=true";
import { default as deposit_45limitsZwI2FW9aUFToC5KLr1dnZqsEnPdDl9DS0x5fapylbrAMeta } from "/opt/buzztimeprobook/frontend/pages/account/deposit-limits.vue?macro=true";
import { default as _91id_93dPwqGhlc7xkZBAoEjkVp10QDOkjRUZ3kgy8ehkTPz50Meta } from "/opt/buzztimeprobook/frontend/pages/scoreboard/player/[id].vue?macro=true";
import { default as responsible_45gamingXIWagV0oweds9x_4SCUdA2tfoeRAYh806fPkjvv5y14Meta } from "/opt/buzztimeprobook/frontend/pages/account/responsible-gaming.vue?macro=true";
export default [
  {
    name: "bets",
    path: "/bets",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/bets.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buzztimeprobook/frontend/pages/login.vue")
  },
  {
    name: "dfs-id",
    path: "/dfs/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/dfs/[id].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/register.vue")
  },
  {
    name: "dfs",
    path: "/dfs",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/dfs/index.vue")
  },
  {
    name: "admin-rake",
    path: "/admin/rake",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/admin/rake.vue")
  },
  {
    name: "cash",
    path: "/cash",
    meta: indexRyUaxaoLNpIZH_zMWEVn_451rpYI_45Hb7thMdpwg9vXJuMMeta || {},
    redirect: "/wallet",
    component: () => import("/opt/buzztimeprobook/frontend/pages/cash/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/admin/index.vue")
  },
  {
    name: "dfs-tickets",
    path: "/dfs/tickets",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/dfs/tickets.vue")
  },
  {
    name: "legal-doc",
    path: "/legal/:doc()",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/legal/[doc].vue")
  },
  {
    name: "leaderboards",
    path: "/leaderboards",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/leaderboards.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    meta: {"middleware":["auth","cash"]},
    component: () => import("/opt/buzztimeprobook/frontend/pages/wallet/index.vue")
  },
  {
    name: "account-verify",
    path: "/account/verify",
    meta: {"middleware":["auth","cash"]},
    component: () => import("/opt/buzztimeprobook/frontend/pages/account/verify.vue")
  },
  {
    name: "dfs-event-id",
    path: "/dfs-event/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/dfs-event/[id].vue")
  },
  {
    name: "scoreboard",
    path: "/scoreboard",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/scoreboard/index.vue")
  },
  {
    name: "event-sport-id",
    path: "/event/:sport()/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/event/[sport]/[id].vue")
  },
  {
    name: "wallet-transactions",
    path: "/wallet/transactions",
    meta: {"middleware":"auth"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/wallet/transactions.vue")
  },
  {
    name: "scoreboard-game-id",
    path: "/scoreboard/game/:id()",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/scoreboard/game/[id].vue")
  },
  {
    name: "scoreboard-team-id",
    path: "/scoreboard/team/:id()",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/scoreboard/team/[id].vue")
  },
  {
    name: "account-deposit-limits",
    path: "/account/deposit-limits",
    meta: {"middleware":["auth","cash"]},
    component: () => import("/opt/buzztimeprobook/frontend/pages/account/deposit-limits.vue")
  },
  {
    name: "scoreboard-player-id",
    path: "/scoreboard/player/:id()",
    meta: {"middleware":"auth-optional"},
    component: () => import("/opt/buzztimeprobook/frontend/pages/scoreboard/player/[id].vue")
  },
  {
    name: "account-responsible-gaming",
    path: "/account/responsible-gaming",
    meta: {"middleware":["auth","cash"]},
    component: () => import("/opt/buzztimeprobook/frontend/pages/account/responsible-gaming.vue")
  }
]